export default ($) => {
    let learnMoreButton  = $('#learn-more-button');
    let personTypeSelect = $('#person-type');
    let interestSelect   = $('#interest');

    let activateInterest = (selectJQElement) => {
        selectJQElement.on('change', function () {
            let currentVal = $(this).find('option:selected').val();
            learnMoreButton.attr('href', currentVal);
        });
    };

    $('select.custom').each(function() {
        let $this = $(this),
            numberOfOptions = $(this).children('option').length;
        let miniSelect = $this.hasClass('mini-select');
        let selectStyledClass = 'select-styled';

        if (miniSelect) {
            selectStyledClass = selectStyledClass + ' mini-styled btn arrow';
        }

        $this.wrap('<div class="select" tabindex="0"></div>');
        $this.closest('.select').addClass( $(this).attr('class'));
        $this.addClass('select-hidden');

        $this.after('<div class="' + selectStyledClass + '"></div>');
        let $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        if (miniSelect) {
            $styledSelect.text($this.data('title'));
            $(this).val('').change();
        }

        let $list = $('<ul />', {
            'class': 'select-options js-' + $(this).attr('id')
        }).insertAfter($styledSelect);
        if (miniSelect) {
            $('<li />', {
                text: $this.data('title'),
                rel: '',
            }).appendTo($list);
        }
        for (let i = 0; i < numberOfOptions; i++) {
            let currentOption = $this.children('option').eq(i);
            $('<li />', {
                text: currentOption.text(),
                rel: currentOption.val(),
            }).appendTo($list);
        }

        let $listItems = $list.children('li');
        $list.hide();

        $styledSelect.click(function(e) {
            e.stopPropagation();
            $('.select-styled.active').not(this).removeClass('active').next('ul.select-options').hide();
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });

        $listItems.click(function(e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $list.hide();
            $this.val($(this).attr('rel')).change();
        });

        $(document).click(function() {
            $styledSelect.removeClass('active');
            $list.hide();
        });
    });

    personTypeSelect.on('change', function () {
        let currentLinks = $(this).find('option:selected').data('links');
        let styledSelect = interestSelect.next('.select-styled');
        let listBox      = interestSelect.siblings('.select-options');

        interestSelect.empty();
        listBox.empty();

        Array.prototype.forEach.call(currentLinks, function (item, index) {
            if (index === 0) {
                styledSelect.text(item['title']);
                learnMoreButton.attr('href', item['url']);
            }

            $('<option />', {
                value: item['url'],
                text: item['title'],
            }).appendTo(interestSelect);

            $('<li />', {
                text: item['title'],
                rel: item['url'],
            }).appendTo(listBox);
        });

        let $listItems = listBox.children('li');

        $listItems.click(function(e) {
            e.stopPropagation();
            styledSelect.text($(this).text()).removeClass('active');
            listBox.hide();
            interestSelect.val($(this).attr('rel')).change();
        });

        activateInterest(interestSelect);
    });

    activateInterest(interestSelect);
};